//COMPONENTS
import { createContext } from "react";
import { useEffect } from "react";
import { useState } from "react";

//CONTEXT
import { useContext } from "react";
import { UserContext } from "../context/userContext";

//API
import { kenzieAPI } from "../requests/api";

//LIBS
import { toast } from "react-toastify";

export const TechContext = createContext({});

const TechProvider = ({children})=>{

    const token = localStorage.getItem("@kenzie-hub: logged-user-token");
    const [ techs, setTechs] = useState([]);

    //MODALS
    const [ viewDetails, setViewDetails ] = useState(null);
    const [ detailsModal, setDetailsModal ] = useState(false);
    const [ addModal, setAddModal ] = useState(false);

    //WHEN PAGE STARTS
    useEffect(()=>{
        getTechs();
    },[]);

    //GET TECHNOLOGIES
    const getTechs = async()=>{
        try{
            const request = await kenzieAPI.get("/profile",{
                headers:{
                    Authorization: `Bearer ${token}`
                }
            })
            setTechs(request.data.techs);
            return request.data.techs;
        }catch(err){
        }
    }

    //SUBMIT ADDING TECH
    const addNewTech = async(data)=>{
        try{
            const request = await kenzieAPI.post("/users/techs",data,{
                headers:{
                    Authorization: `Bearer ${token}`
                }
            })
            getTechs();
            toast.success("Tecnologia adicionada com sucesso");
            setAddModal(false);
        }catch(err){
            console.log(err)
        }
    }
    
    const submitTech = (data)=>{
        addNewTech(data);
    }
    
    //VIEW DETAILS AUX
    const viewTechDetails = (tech)=>{
        setDetailsModal(true)
        setViewDetails(tech)
    }

    //DELETE A TECHNOLOGY
    const deleteTechnology = async()=>{
        try{
            const request = await kenzieAPI.delete(`/users/techs/${viewDetails.id}`,{
                headers:{
                    Authorization: `Bearer ${token}`
                }
            })
            getTechs();
            toast.success("Tecnologia deletada com sucesso");
            setDetailsModal(false);
        }catch(err){
            console.log(err)
        }
    }

    //UPDATING A TECHNOLOGY
    const updateTechnology = async(data)=>{
        try{
            const request = await kenzieAPI.put(`/users/techs/${viewDetails.id}`,data,{
                headers:{
                    Authorization: `Bearer ${token}`
                }
            })
            getTechs();
            setDetailsModal(false);
            toast.success("Tecnologia atualizada com sucesso");
        }catch(err){
            console.log(err)
        }
    }

    const submitUpdate = (data)=>{
        updateTechnology(data);

        console.log(data)
    }

    return(
        <TechContext.Provider value={{
            techs, submitTech, setTechs,
            viewTechDetails, viewDetails,
            detailsModal, setDetailsModal,
            deleteTechnology, addModal,
            setAddModal, submitUpdate, setTechs
        }}>
                                        
            {children}
        </TechContext.Provider>
    )
}

export default TechProvider